import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { ClientDataType } from 'modules/queryBuilder/types';

export const useRequirementPretext = (dataType: ClientDataType, isCatalogESIndex: boolean) => {
  const { t } = useTranslation();
  if (isCatalogESIndex) {
    return t('storybook.layouts.requirement.pretext.catalog');
  }
  return dataType === ClientDataType.User
    ? t('storybook.layouts.requirement.pretext.user')
    : t('storybook.layouts.requirement.pretext.event');
};
